import React from 'react';
import { ip } from '../../../config';

const UsersListRow = ({ users }) => {

    function getUserEventCount(id) {
        let value = 0;
        fetch(ip + "/users/" + id + "/events/?userId=" + id, {
            method: 'GET',
            mode: 'cors'
        })
        
        .then(response => response.json())
        .then(data => {
            value = data.length;
        });
        return value;
    }

    return (
        <React.Fragment>
            {
                users.map((user, idx) => {
                    console.log(user);
                    return (
                        <tr key={idx}>
                            <th scope="row">{user.id}</th>
                            <td>{user.name}</td>
                            <td>{user.username}</td>
                            <td>{user.role}</td>
                            {/* <td>{getUserEventCount(user.id)}</td> */}
                        </tr>
                    )
                })
            }
        </React.Fragment>
    );
}

export default UsersListRow;